import { useDispatch, useSelector } from "react-redux";
import { setStep } from "../../store/reducers/authSlice";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useVerifyOtpMutation } from "../../api/authApi";
import EiLogo from "../../Icons/EiLogo.svg";
import ICTLogo from "../../Icons/LOGOICT.png";
import { clearCahce, getToken, setToken } from "../../services/Token";
import jwtDecode from "jwt-decode";
import { useLazyGetEmployeeListQuery } from "../../api/addEmployeeApi";
import { toast } from "react-toastify";

const OTPScreen = () => {
  const dispatch = useDispatch();
  const { userCredentials } = useSelector((state) => state.auth);
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [error, setError] = useState("");
  const [countdown, setCountdown] = useState(0);
  const [canResend, setCanResend] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const sessionExpired = queryParams.get("sessionExpired");
  const history = useNavigate();

  const navigate = useNavigate();

  const [verifyOtp, { isLoading, isSuccess, data }] = useVerifyOtpMutation();
  const [getEmployeeList, empData] = useLazyGetEmployeeListQuery();

  const handleOtpChange = (index, value) => {
    if (value.length > 1) return;

    const newOtp = [...otp];

    newOtp[index] = value;
    setOtp(newOtp);

    if (value && index < 5) {
      const nextInput = document.getElementById(`otp-${index + 1}`);
      if (nextInput) nextInput.focus();
    }
    if (error) setError("");
  };

  const handleKeyDown = (index, e) => {
    if (e.key === "Enter") {
      handleVerifyOtp();
      return;
    }
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      const prevInput = document.getElementById(`otp-${index - 1}`);
      if (prevInput) prevInput.focus();
    }
  };

  const handleVerifyOtp = async () => {
    const otpString = otp.join("");

    if (otpString.length !== 6) {
      setError("Please enter all 6 digits");
      return;
    }

    if (!/^\d{6}$/.test(otpString)) {
      setError("OTP must contain only numbers");
      return;
    }

    try {
      await verifyOtp({
        ...userCredentials,
        otp: otpString,
      }).unwrap();
    } catch (error) {
      console.error("OTP verification failed:", error);
      setError("Invalid OTP. Please try again.");
      toast.error(error?.data?.error || "Invalid OTP. Please try again.")
    }
  };

  const handleResendOtp = () => {
    setOtp(["", "", "", "", "", ""]);
    setError("");
    alert("OTP has been resent to your email");
    setCountdown(60);
    setCanResend(false);
  };

  const handleBack = () => {
    dispatch(setStep("login"));
  };

  useEffect(() => {
    if (sessionExpired === "true") {
      setError("Session Expired");
      setSnackbarOpen(true);
    }
    clearCahce();
  }, []);
  useEffect(() => {
    if (isSuccess) {
      setToken("Token", data.token);
      setToken("isEmailValidationEnabled", data.isEmailValidationEnabled);
      const decoded = jwtDecode(data.token);
      const roles = decoded.roles;
      setToken("roles", roles);
      const email = decoded.professionalEmail;
      setToken("professionalEmail", email);
      setToken("employeeId", decoded.sub);
      setToken("tenantCountry", decoded.tenantCountry);
      setToken("dashboards", decoded.dashboards);
      const Id = decoded.employeeId;
      setToken("Id", Id);
      setToken("userId", decoded.tenantId);
      const expiryTime = decoded.exp;
      let expiryTimestamp = expiryTime;
      let date = new Date(expiryTimestamp * 1000);
      let hours = String(date.getHours()).padStart(2, "0");
      let minutes = String(date.getMinutes()).padStart(2, "0");
      let seconds = String(date.getSeconds()).padStart(2, "0");
      let timeString = `${hours}:${minutes}:${seconds}`;
      setToken("expiryTime", timeString);
      localStorage.setItem("isLogin", data.isLogin);
      localStorage.setItem(
        "loggedInToday",
        data?.sigindetails?.isloggedintoday
      );
      localStorage.setItem(
        "lastLoggedInLocation",
        data?.sigindetails?.lastloggedinlocation
      );
      localStorage.setItem(
        "lastLoggedInTime",
        data?.sigindetails?.lastloggedintime
      );
      if (roles[0] !== "SUPERADMIN") {
        getEmployeeList();
      } else if (roles[0] === "SUPERADMIN") {
        history("/superadmin");
      }
    } else if (error) {
      setLoading(false);
      const errorMessage = error.data?.message;
      setError(errorMessage);
      setSnackbarOpen(true);
    }
  }, [isSuccess, error]);

  console.log({empData,isSuccess,error},'sdegfrthyusdfgrt')

  useEffect(() => {
    if (empData.isSuccess) {
      const loggedInUserId = getToken("Id");
      const matchedEmployee = empData.data.find(
        (employee) => employee.id === loggedInUserId
      );
      if (matchedEmployee) {
        setToken("employeeName", matchedEmployee.name);
      }
      setLoading(false);
      history("/dashboard");
    } else if (empData.error) {
      setLoading(false);
      const errorMessage = empData.error.data?.message;
      setError(errorMessage);
      setSnackbarOpen(true);
    }
  }, [empData.isSuccess, empData.data, empData.isError]);

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div className="relative flex justify-center">
          <img src={ICTLogo} alt="ICT Logo" className="w-16 h-16" />
        </div>
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-8">
          <div className="text-center mb-4">
            <div className="flex justify-center mb-4">
              <div className="flex items-center space-x-2">
                <img src={EiLogo} alt="EI Logo" className="w-10 h-10" />
                <div className="text-center mb-[-2rem] mt-[-2rem]">
                  <h2 className="text-3xl font-serif text-purple-800 mb-[0rem]">
                    <span className="font-extrabold">work</span>
                    <span className="font-extrabold">force</span>
                    <span className="text-4xl font-extrabold text-blue-600">
                      HR
                    </span>
                  </h2>
                </div>
              </div>
            </div>
            <h2 className="text-2xl font-semibold text-gray-700 mb-2">
              Enter OTP
            </h2>
            <p className="text-sm text-gray-600">
              We've sent a 6-digit code to your email
            </p>
          </div>
          <div className="space-y-6">
            <div className="flex justify-center space-x-3">
              {otp.map((digit, index) => (
                <input
                  key={index}
                  id={`otp-${index}`}
                  type="text"
                  inputMode="numeric"
                  maxLength={1}
                  value={digit}
                  onChange={(e) => handleOtpChange(index, e.target.value)}
                  onKeyDown={(e) => handleKeyDown(index, e)}
                  className="w-12 h-12 text-center text-lg font-semibold border-2 border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent"
                />
              ))}
            </div>

            {error && (
              <div className="text-sm text-red-600 text-center">{error}</div>
            )}

            <button
              onClick={handleVerifyOtp}
              disabled={isLoading}
              className="w-full bg-blue-600 hover:bg-blue-700 disabled:bg-blue-400 text-white font-medium py-2 px-4 rounded-md transition duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
            >
              {isLoading ? "Verifying..." : "Verify OTP"}
            </button>

            <div className="text-center space-y-2">
              {/* <button
                disabled={!canResend || countdown > 0}
                onClick={handleResendOtp}
                className={`text-sm font-medium transition-colors ${
                  canResend && countdown === 0
                    ? "text-blue-600 hover:text-blue-800 cursor-pointer"
                    : "text-gray-400 cursor-not-allowed"
                }`}
              >
                {countdown > 0 ? `Resend OTP in ${countdown}s` : "Resend OTP"}
              </button> */}
              <div>
                <button
                  onClick={handleBack}
                  className="text-gray-600 hover:text-gray-800 text-sm"
                >
                  ← Back to login
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OTPScreen;
